// frontend/src/services/assignmentService.js
// Fetches a read-only, assignment-based view of drivers for a specific site (Phase 7 uses siteId).
import axios from 'axios';

/**
 * Fetches drivers assigned to a specific site.
 * Used for "Active" and "Reserved" lists in the UI.
 */
export async function fetchSiteAssignments(siteId, { statuses, agencyId, search } = {}) {
  if (siteId == null) return [];

  const params = {};

  // Keep same param semantics as your current backend expects
  if (Array.isArray(statuses) && statuses.length) {
    params.statuses = statuses.join(',');
  }
  if (agencyId) params.agency_id = agencyId;
  if (search) params.search = search;

  // IMPORTANT: match your backend route prefixing.
  // Using /ups/... style as per your existing implementation.
  const { data } = await axios.get(`/ups/sites/${Number(siteId)}/assignments`, { params });

  return Array.isArray(data) ? data : [];
}

/**
 * Phase 8.7B — orphaned / blocked assignments (UPS-admin only)
 * Fetches assignments that are no longer linked to a valid site or configuration.
 */
export async function fetchOrphanedAssignments(siteId, { statuses, agencyId, search } = {}) {
  if (siteId == null) return [];

  const params = {};

  if (Array.isArray(statuses) && statuses.length) {
    params.statuses = statuses.join(',');
  }
  if (agencyId) params.agency_id = agencyId;
  if (search) params.search = search;

  const { data } = await axios.get(
    `/ups/sites/${Number(siteId)}/assignments/orphaned`,
    { params }
  );

  return Array.isArray(data) ? data : [];
}

// Phase 8.7C — cleanup-only actions (UPS-admin)
export async function completeAssignment(siteId, assignmentId) {
  const { data } = await axios.patch(
    `/ups/sites/${Number(siteId)}/assignments/${Number(assignmentId)}/complete`
  );
  return data?.assignment || null;
}

export async function cancelAssignment(siteId, assignmentId) {
  const { data } = await axios.patch(
    `/ups/sites/${Number(siteId)}/assignments/${Number(assignmentId)}/cancel`
  );
  return data?.assignment || null;
}

// Phase 8.7D — UPS approval (requested -> confirmed)
export async function approveAssignment(siteId, assignmentId) {
  const { data } = await axios.patch(
    `/ups/sites/${Number(siteId)}/assignments/${Number(assignmentId)}/approve`
  );
  return data?.assignment || null;
}
